import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import AuthService from 'services/auth'
import Comission from 'services/Comission'
import BusinessNavbar from 'components/Navbars/BusinessNavbar'
import ItemTabs from 'components/ItemTabs'
import BusinessBillList from 'components/Lists/BusinessBillList'
import ProfessionalCreditList from 'components/Lists/ProfessionalCreditList'
import ScheduleList from 'components/Lists/ScheduleList'

import { 
  Container, 
  InfoText, 
  InfoContainer,
  Row,
  Info,
  SubTitle,
  MoneyTextMask
} from '../../styles'

export default function Daily () {
  const location = useLocation ()
  const { day, earningType, category, selectedProfessional } = location.state
  const [dayEarnings, setDayEarnings] = useState (location.state.dayEarnings)
  const [bonuses, setBonuses] = useState ([])
  const [discounts, setDiscounts] = useState ([])
  const [bonusTotal, setBonusTotal] = useState (0)
  const [discountTotal, setDiscountTotal] = useState (0)
  const dailyTotalEarnings = Comission.getTotalEarnings (dayEarnings, earningType, category)
  const dailyBusinessEarnings = Comission.getBusinessEarnings (dayEarnings, earningType, category)
  const dailyProfessionalEarnings = Comission.getProfessionalEarnings (dayEarnings, earningType, category)
  const [filteredDayEarnings, setFilteredDayEarnings] = useState ([])
  const isAllProfessionalsSelected = selectedProfessional.value === 'all_professionals'
  const canViewTotalEarnings = AuthService.hasPermission ('financial.total_earnings')
  const canViewBusinessEarnings = AuthService.hasPermission ('financial.business_earnings')

  const TYPE_OPTION_LIST = [
    {label: 'Comandas do salão', value: 'bill'},
    {label: 'Agendamentos Cutilei', value: 'cutilei'},
    bonuses.length > 0 && {label: 'Bônus', value: 'bonus'},
    discounts.length > 0 && {label: 'Descontos', value: 'discount'}
  ].filter (Boolean)

  const [typeOption, setTypeOption] = useState (() => {
    if (earningType.value === 'all_earnings') {
      return TYPE_OPTION_LIST[0] || {label: 'Comandas do salão', value: 'bill'}
    }
    return earningType
  })
  
  useEffect (() => {
    if (typeOption) {
      handleTypeOptionSelected (typeOption.value)
    }
  }, [])

  useEffect (() => {
    setBonuses (dayEarnings.filter (earning => earning.type === 'bonus'))
    setDiscounts (dayEarnings.filter (earning => earning.type === 'discount'))
  }, [dayEarnings])

  useEffect (() => {
    setBonusTotal (bonuses.reduce ((total, bonus) => total + bonus.value, 0))
  }, [bonuses])

  useEffect (() => {
    setDiscountTotal (discounts.reduce ((total, bonus) => total + bonus.value, 0))
  }, [discounts])

  const handleTypeOptionSelected = typeOptionValue => {
    setFilteredDayEarnings (dayEarnings.filter (e => e.type === typeOptionValue))
    const foundOption = TYPE_OPTION_LIST.find (o => o.value === typeOptionValue)
    if (foundOption) setTypeOption (foundOption)
  }

  const handleDeleteCredit = credit => {
    const index = TYPE_OPTION_LIST.findIndex (o => o && o.value === typeOption.value)
    const filteredEarnings = dayEarnings.filter (e => e.id !== credit.id)
    
    setDayEarnings (filteredEarnings)
    setFilteredDayEarnings (filteredEarnings)

    if (!filteredEarnings.some (e => e.type === credit.type)) {
      const previousOption = TYPE_OPTION_LIST[index - 1]
      if (previousOption) handleTypeOptionSelected (previousOption)
    }
  }

  return (
    <Container>
      <BusinessNavbar/>
      <InfoContainer style={{alignItems: 'center'}}>
        <SubTitle style={{marginBottom: 7}}>Total do dia - {day}</SubTitle>
        <Info style={{alignItems: 'center', height: 'auto'}}>
          {canViewTotalEarnings && (
            <Row>
              <InfoText>Faturamento bruto:</InfoText>
              <MoneyTextMask value={dailyTotalEarnings}/>
            </Row>
          )}
          <Row>
            <InfoText>
              Comissão {isAllProfessionalsSelected ? 'dos profissionais: ' : 'do profissional: '}
            </InfoText>
            <MoneyTextMask value={dailyProfessionalEarnings}/>
          </Row>
          {bonuses.length > 0 && (
            <Row>
              <InfoText>Bônus do profissional:</InfoText>
              <MoneyTextMask value={bonusTotal ?? 0}/>
            </Row>
          )}
          {discounts.length > 0 && (
            <Row>
              <InfoText>Descontos do profissional:</InfoText>
              <MoneyTextMask value={discountTotal ?? 0}/>
            </Row>
          )}
          {(bonuses.length > 0 || discounts.length > 0) && (
            <Row>
              <InfoText>Total do profissional:</InfoText>
              <MoneyTextMask value={dailyProfessionalEarnings + (bonusTotal ?? 0) + (discountTotal ?? 0)}/>
            </Row>
          )}
          {canViewBusinessEarnings && (
            <Row>
              <SubTitle>Total do salão:</SubTitle>
              <MoneyTextMask value={dailyBusinessEarnings}/>
            </Row>
          )}
        </Info>
      </InfoContainer>
      {typeOption && (
        <ItemTabs
          tabs={TYPE_OPTION_LIST}
          selectedTab={typeOption.value}
          onTabChange={handleTypeOptionSelected}
          containerStyle={{paddingTop: 0, marginBottom: 10}}
          tabWidth={180}
        />
      )}
      {typeOption?.value === 'cutilei' ? (
        <ScheduleList
          schedules={filteredDayEarnings}
          totalSchedules={filteredDayEarnings.length}
          hasMore={false}
          onScroll={() => null}
          detailed={true}
        />
      ) : typeOption?.value === 'bill' ? (
        <BusinessBillList
          bills={filteredDayEarnings}
          type={typeOption}
          category={category}
          professionalID={isAllProfessionalsSelected ? null : selectedProfessional.value}
          showComissions={true}
          onDelete={bill => setFilteredDayEarnings (filteredDayEarnings.filter (e => e.id !== bill.id))}
        />
      ) : (
        <ProfessionalCreditList
          credits={filteredDayEarnings}
          type={typeOption?.value}
          onEdit={credit => {
            setDayEarnings (dayEarnings.map (e => e.id === credit.id ? {...credit} : e))
          }}
          onDelete={handleDeleteCredit}
          styles={{width: 960, minWidth: 840}}
        />
      )}
    </Container>
  )
}
